import { ORGANIC_REFERRER_PATTERNS_OBJ } from '@packages/shared/core/common/constants';

export const isOrganicChannel = (referrer: string) => {
  return Object.values(ORGANIC_REFERRER_PATTERNS_OBJ).some((pattern) => pattern.test(referrer));
};
